import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface WrapProps {
  style?: {
    [key: string]: string;
  };
  className?: string;
}

const Wrap: React.FC<WrapProps> = ({ style, className, children }) => {
  return (
    <div style={style} className={joinClassnames("o-wrap", className)}>
      {children}
    </div>
  );
};

export default Wrap;
